import React, { useState, useEffect } from 'react'

import 'web_common/css/LimnTech.css'
import { db } from 'web_common/tsx/api/db/Api'
import { Company, CompanyAdminPrivilege, LifemarkUserModel, ProcessedPathInfo } from 'web_common/tsx/api/db/Models'
import ApiError from 'web_common/tsx/components/misc/ApiError'
import PermissionDenied from 'web_common/tsx/components/misc/PermissionDenied'
import Loading from 'web_common/tsx/components/misc/Loading'

import ProposedPathAdminTable from 'components/paths/proposed/list/ProposedPathAdminTable'
import ProposedPathUserTable from 'components/paths/proposed/list/ProposedPathUserTable'

interface ProposedPathListProps {

}

const ProposedPathList: React.FC<ProposedPathListProps> = (props) => {
    const [apiError, setApiError] = useState<boolean>(false)
    const [lifemarkUser, setLifemarkUser] = useState<LifemarkUserModel|undefined>(undefined)
    const [company, setCompany] = useState<Company|undefined>(undefined)
    const [proposedPaths, setProposedPaths] = useState<Array<ProcessedPathInfo>|undefined>(undefined)

    useEffect(() => {
        const onCurrentUser = (response: LifemarkUserModel|undefined) => {
            if(response === undefined)
            {
                setApiError(true)
            }
            else
            {
                setLifemarkUser(response)
            }
        }

        db.current_user(onCurrentUser)
    }, [])

    useEffect(() => {
        if(lifemarkUser !== undefined)
        {
            const onCompany = (response: Company|undefined) => {
                if(response === undefined)
                {
                    setApiError(true)
                }
                else
                {
                    setCompany(response)
                }
            }

            db.company_detail(lifemarkUser.company, onCompany)
        }
    }, [lifemarkUser])

    useEffect(() => {
        if(lifemarkUser !== undefined)
        {
            const onCompletion = (response: Array<ProcessedPathInfo>|undefined) =>
            {
                if(response === undefined)
                {
                    setApiError(true)
                }
                else
                {
                    setProposedPaths(response)
                }
            }

            db.proposed_path_list(
                lifemarkUser.company,
                onCompletion)
        }
    }, [lifemarkUser])

    if(apiError === true)
    {
        return <ApiError/>
    }
    else if(lifemarkUser !== undefined)
    {
        if(lifemarkUser.privilege === CompanyAdminPrivilege.NONE)
        {
            return (
                <PermissionDenied/>
            )
        }
        else if(company !== undefined && proposedPaths !== undefined)
        {
            if(lifemarkUser.privilege === CompanyAdminPrivilege.ADMIN)
            {
                return (
                    <div className='limn-form-container'>
                        <h1 className='limn-header'> Proposed Paths </h1>
                        <ProposedPathAdminTable
                            proposedPathList={proposedPaths}
                        />
                    </div>
                )
            }
            else
            {
                return (
                    <div className='limn-form-container'>
                        <h1 className='limn-header'> Proposed Paths </h1>
                        <ProposedPathUserTable
                            proposedPathList={proposedPaths}
                        />
                    </div>
                )
            }
        }
        else
        {
           return (
                <div className='limn-form-container'>
                    <h1 className='limn-header'> Proposed Paths </h1>
                    <Loading/>
                </div>
            )
        }
    }
    else
    {
        return (
            <div className='limn-form-container'>
                <h1 className='limn-header'> Proposed Paths </h1>
                <Loading/>
            </div>
        )
    }
}

export default ProposedPathList
